<!--
  @Description: 通用模板
  @Author: wang.y 
  @Date: 2022-02-17 
-->
<template>
  <div>
    <div class="container-title">
      <div class="lf">{{list[temp]['title']}}</div>
      <div class="rt">
        <span>{{list[temp]['title']}}数据由</span>
        <img class="logo" :src="$store.state.static_img_url+'pic/logo.png'" @click="haddleApplyTry2(32)">
        <span>提供支持</span>
      </div>
    </div>
    <div class="pro-container">
      <div class="container-lt">
        <slot name="theme"></slot>
        <div class="pro-data">
          <div class="sec-title">
            <div class="lt">{{list[temp]['data_title']}}</div>
            <div class="line"></div>
            <div class="rt">
              <slot name="data-lk-btn"></slot>
            </div>
          </div>
          <div class="pro-data-cnt">
            <Spin fix v-if="$parent.event_loading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
            <slot name="data"></slot>
          </div>
        </div>
      </div>
      <div class="container-rt">
        <div class="sec-title">
          <div class="lt">动态</div>
          <div class="line"></div>
          <div class="rt">
            <slot name="list-lk-btn"></slot>
          </div>
        </div>
        <div class="info-flow">
          <Spin fix v-if="$parent.dynamic_loading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
          <slot name="list"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['haddleApplyTry2'],
  components: {},
  created() { },
  mounted() { },
  props: ['temp'],
  data() {
    return {
      list: {
        1: {
          title: '早期项目发掘机',
          data_title: '融资项目'
        },
        2: {
          title: '未来头条公司',
          data_title: '融资项目'
        },
        3: {
          title: '活跃机构领域版图',
          data_title: '活跃机构'
        },
        4: {
          title: '科技巨头投资版图',
          data_title: '科技巨头'
        }
      }
    }
  },
  computed: {},
  methods: {
    
  }
}
</script>
<style lang="stylus" scoped>
.pro-container
  display flex
  justify-content space-between
  .sec-title
    display flex
    justify-content space-between
    align-items center
    padding 0 20px
    height 50px
    .line
      flex 1
      height 1px
      background #E9E9E9
      margin 0 10px
    .lt
      font-size 16px
      color #333333
    .lk-btn
      color #FF8824
      cursor pointer
  .container-lt
    width 730px
    .pro-data
      background #F8F9FA
      .pro-data-cnt
        padding 0 20px
        height 354px
        overflow auto
        position relative
        >>> .company-table
          .ivu-table
            tr
              th
                background #EEF5FF
              th, td
                &:first-of-type
                  .ivu-table-cell
                    padding-left 20px
            .ivu-table-row-hover
              td
                background #f8fbff
          .comp-btn
            width 40px
            height 24px
            border 1px solid #FF8824
            display flex
            justify-content center
            align-items center
            font-size 12px
            color #FF8824
            cursor pointer
  .container-rt
    width 350px
    height 720px
    background #F8F9FA
    .sec-title
      padding 0 15px
    .info-flow
      position relative
      height 650px
      overflow auto
      padding 0 15px
      &::-webkit-scrollbar-track
        background-color transparent !important
      &::-webkit-scrollbar
        background-color transparent !important
      &::-webkit-scrollbar-thumb
        background-color #CCCCCC
</style>